import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Imagen from "./Graphic/imagen/imagen";

import "./variable";

import "./inicio.css";

function Inicio() {
  const navigate = useNavigate();

  useEffect(() => {
    //EfectoCss();
  }, []);

  const handleClick = () => {
    navigate("/contactarme");
  };

  //console.log("variable swap: " +  variable.swap );
  return (
    <section className="main-banner">
      <div className="grid-container">
        <div className="content">
          {/*
            Hemos eliminado los <span> individuales "eSigloXXI servicio" y "Dominamos la tecnologia"
            porque el nuevo h1 ya incorpora el nombre de la marca y la propuesta de valor.
            Tenerlos duplicados sería redundante y podría diluir el peso del h1 para SEO.
          */}
          {/*
            El antiguo bloque de texto comentado (La generación de nosotros...)
            también se elimina ya que el nuevo h1 y el subtítulo son mucho más efectivos.
          */}

          <div id="descriptionInicio">
            {/* Este h1 es el título principal de tu página, debe ser único y contener tus palabras clave más importantes. */}
            <h1 className="descriptionInicio-title">
              {" "}
              {/* Cambié el className a descriptionInicio-title para mayor claridad */}
              <span className="line-1">
                Soluciones Digitales que Impulsan tu Negocio en la Era de
                Internet.
              </span>{" "}
              <br />
              {/* Usar <br/> solo si necesitas un salto de línea forzado en el mismo h1 */}
              <span className="line-2">
                Expertos en Tecnología y Desarrollo Web en Córdoba, Argentina.
              </span>
            </h1>
            {/* Este párrafo es crucial para añadir más detalle, palabras clave secundarias y un beneficio. */}
            <p className="subtitle">
              En eSiglo XXI Servicios, creamos sitios web profesionales,
              optimizamos tu presencia online y brindamos soporte informático
              para que tu empresa crezca en el mercado digital.
            </p>
            {/*
              Aquí es un buen lugar para añadir un botón de Llamada a la Acción (CTA)
              que dirija a "Contactanos" o "Descubre nuestros servicios".
              Por ejemplo: */}
            <button className="btn" onClick={handleClick}>
              ¡Impulsa tu Negocio Ahora!
            </button>
          </div>
        </div>
        <div className="graphic-principal">
          <Imagen />{" "}
          {/* Asegúrate de que este componente esté definido e importado */}
        </div>
      </div>
    </section>
  );
}
export default Inicio;
